export default "__VITE_ASSET__C9sCSj5Q__"